import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPlaybooks, fetchExecutions, setPlaybookActive, approveExecution, rejectExecution, fetchTriggerLog } from '../../services/api/automationService';

export const loadAutomation = createAsyncThunk('automation/load', async () => {
  const [playbooks, executions, triggerLog] = await Promise.all([fetchPlaybooks(), fetchExecutions(), fetchTriggerLog()]);
  return { playbooks, executions, triggerLog };
});

export const togglePlaybook = createAsyncThunk(
  'automation/toggle',
  async ({ id, isActive }) => setPlaybookActive(id, isActive)
);

export const approveAutomationExecution = createAsyncThunk('automation/approveExecution', async (id) => approveExecution(id));
export const rejectAutomationExecution = createAsyncThunk('automation/rejectExecution', async (id) => rejectExecution(id));

const automationSlice = createSlice({
  name: 'automation',
  initialState: { status: 'idle', error: null, playbooks: [], executions: [], triggerLog: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAutomation.pending, (state) => { state.status = 'loading'; })
      .addCase(loadAutomation.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.playbooks = action.payload.playbooks;
        state.executions = action.payload.executions;
        state.triggerLog = action.payload.triggerLog;
      })
      .addCase(loadAutomation.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(togglePlaybook.fulfilled, (state, action) => {
        const pb = state.playbooks.find((p) => p.id === action.payload.id);
        if (pb) pb.isActive = action.payload.isActive;
      })
      .addCase(approveAutomationExecution.fulfilled, (state, action) => {
        const ex = state.executions.find((e) => e.id === action.payload.id);
        if (ex) Object.assign(ex, action.payload);
      })
      .addCase(rejectAutomationExecution.fulfilled, (state, action) => {
        const ex = state.executions.find((e) => e.id === action.payload.id);
        if (ex) Object.assign(ex, action.payload);
      });
  }
});

export default automationSlice.reducer;
